import classNames from "classnames";
import "./button.scss";

export interface ButtonProps {
  onClick?: (e: any) => void;
  className?: string;
  testId?: string;
  disabled?: boolean;
  hidden?: boolean;
  label?: string;
  primary?: boolean;
  warning?: boolean;
  outline?: boolean;
  info?: boolean;
  full?: boolean;
  link?: boolean;
  goback?: boolean;
  add?: boolean;
}

export const Button = (props: React.PropsWithChildren<ButtonProps>) => {
  return (
    <button
      className={classNames({
        "button": true,
        "primary": props.primary,
        "warning": props.warning,
        "outline": props.outline, 
        "info": props.info, 
        "goback": props.goback,
        "link": props.link,
        "add": props.add,
        "full": props.full
      })}
      onClick={props?.onClick}
      data-testid={props?.testId ?? "button-test"}
      disabled={props?.disabled}
      hidden={props?.hidden}
    >
      {props?.label}{props?.children}
    </button>
  );
};


